module.exports = "<div class=\"card-box\">\n  <div class=\"card-box-header\" *ngIf=\"isHeader\">\n    <ng-content select=\".card-box-header\"></ng-content>\n  </div>\n  <div class=\"card-box-body\">\n    <ng-content select=\".card-box-body\"></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/card-box/card-box.component.html
// module id = ./src/app/shared/card-box/card-box.component.html
// module chunks = main